import React, { ReactNode } from "react";
import ModelFramer from "../framerMotion/ModelFramer";
import Image from "../images/Image";
import useTranslation from "../CustomHooks/useTranslation";

type MainModelProps = {
  children?: ReactNode; // Optional children prop
  isClose?: boolean;
  loginFlow?: boolean;
  handleClose?: () => void;
  modelWidth?: string;
};

export default function MainModel({modelWidth, children, isClose, loginFlow, handleClose }: MainModelProps) {
  const { notEnglish } = useTranslation({});

  const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
    // Check if the click is on the backdrop and not inside the modal
    if (event.target === event.currentTarget && handleClose) {
      handleClose();
    }
  };

  return (
    <div
      dir={`${notEnglish ? "rtl" : "ltr"}`}
      className={`fixed flex items-center justify-center ${loginFlow ? '' : 'bg-black bg-opacity-60 inset-0 z-50'}`}
      onClick={handleBackdropClick} // Handle click outside the modal
    >
      <ModelFramer className={`bg-white ${modelWidth ? modelWidth : 'w-[570px]'} rounded-lg p-6 shadow-xl relative`}>
        {isClose && (
          <div className="flex justify-end">
            <Image
              src="close"
              onClick={() => handleClose && handleClose()}
              className="cursor-pointer"
            />
          </div>
        )}
        {children}
      </ModelFramer>
    </div>
  );
}
